// NATIVE 


// INSTALLED 
import { types } from '../types/types';
import AsyncStorage from '@react-native-async-storage/async-storage';


// CUSTOM 



/**
 * get user data in localstorage
*/
export const storageGetCurrentUser = async() => {
    const user = await AsyncStorage.getItem( types.storage.userStorage ) || '{}';
    return JSON.parse(user);
}



/**
 * get user super admin permissions in localstorage
*/
export const storageGetAdminPermissions = async() => {
    const permissions = await AsyncStorage.getItem( types.storage.permissionsStorage ) || '{}';
    return JSON.parse(permissions);
}



/**
 * get user permissions assigned in localstorage
*/
export const storageGetAssignedUserPermissions = async() => {
    const permissions = await AsyncStorage.getItem( types.storage.userPermissionsStorage ) || '{}';
    return JSON.parse(permissions);
}


/**
 * get areas company in localstorage
*/
// export const storageGetAreas = async() => {
//     const areas = await AsyncStorage.getItem( types.storage.areasStorage ) || '{}';
//     return JSON.parse(areas);
// }


/**
 * get cargos localstorage
*/
// export const storageGetCargos = async() => {
//     const cargos = await AsyncStorage.getItem( types.storage.cargosStorage ) || '{}';
//     return JSON.parse(cargos);
// }




/**
 * get parametros localstorage
*/
// export const storageGetParametros = async() => {
//     const parametros = await AsyncStorage.getItem( types.storage.parametrosStorage ) || '{}';
//     return JSON.parse(parametros);
// }

